import { render } from "./ViewBlog.vue?vue&type=template&id=0c7f5b62&scoped=true"
import script from "./ViewBlog.vue?vue&type=script&lang=js"
export * from "./ViewBlog.vue?vue&type=script&lang=js"

import "./ViewBlog.vue?vue&type=style&index=0&id=0c7f5b62&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c7f5b62"]])

export default __exports__